/**
 * @generated SignedSource<<15f1f8763de1e03baa87691daed2eaad>>
 * @relayHash d73a10603645f454a94e1ca5e43f1ce6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a6653f1a1ff7b6936012fffcaca69d1c6f138190dbb860c41b727f029735e565

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GraphIntegrationDirectoryItemType = "ACTION" | "CUSTOM_SKILL" | "FORGE_SKILL" | "FORGE_TOOL" | "MCP_SERVER" | "MCP_TOOL" | "PLATFORM_SKILL" | "SKILL" | "%future added value";
export type GraphIntegrationSkillSurface = "ROVO_AGENTS" | "ROVO_CLAW" | "STUDIO" | "%future added value";
export type AgentStudioSkillsQuery$variables = {
  cloudId: string;
  contextAri: string;
  isForgeSkillsEnabled: boolean;
  isStudioCustomSkillsM1FrontendEnabled: boolean;
  relevantFor?: ReadonlyArray<GraphIntegrationDirectoryItemType> | null;
  surface?: GraphIntegrationSkillSurface | null;
};
export type AgentStudioSkillsQuery$data = {
  readonly connectedAppsQuery?: {
    readonly " $fragmentSpreads": FragmentRefs<"SkillsFilter_connectedAppsQuery">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SkillsFilter_productsQuery" | "SkillsList_AtlassianAgentStudioSkills_fragmentRef">;
};
export type AgentStudioSkillsQuery = {
  response: AgentStudioSkillsQuery$data;
  variables: AgentStudioSkillsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contextAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isForgeSkillsEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isStudioCustomSkillsM1FrontendEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "relevantFor"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "surface"
},
v6 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v7 = {
  "kind": "Variable",
  "name": "relevantFor",
  "variableName": "relevantFor"
},
v8 = {
  "kind": "Variable",
  "name": "contextAri",
  "variableName": "contextAri"
},
v9 = {
  "kind": "Variable",
  "name": "surface",
  "variableName": "surface"
},
v10 = [
  (v6/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  (v7/*: any*/),
  {
    "kind": "Literal",
    "name": "surface",
    "value": "ROVO_AGENTS"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = {
  "kind": "ScalarField",
  "name": "id"
},
v13 = {
  "kind": "ScalarField",
  "name": "name"
},
v14 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v15 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v16 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v17 = [
  (v12/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AgentStudioSkillsQuery",
    "selections": [
      {
        "args": [
          (v6/*: any*/),
          {
            "kind": "Variable",
            "name": "isStudioCustomSkillsM1FrontendEnabled",
            "variableName": "isStudioCustomSkillsM1FrontendEnabled"
          },
          (v7/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "SkillsList_AtlassianAgentStudioSkills_fragmentRef"
      },
      {
        "args": [
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "SkillsFilter_productsQuery"
      },
      {
        "condition": "isForgeSkillsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": [
                    (v8/*: any*/)
                  ],
                  "kind": "FragmentSpread",
                  "name": "SkillsFilter_connectedAppsQuery"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "connectedAppsQuery"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "AgentStudioSkillsQuery",
    "selections": [
      {
        "args": (v10/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphIntegrationDirectoryItemEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isGraphIntegrationDirectoryItem"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      {
                        "concreteType": "GraphIntegrationSkillUiMetadata",
                        "kind": "LinkedField",
                        "name": "uiMetadata",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "color"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "iconKey"
                          }
                        ]
                      },
                      {
                        "concreteType": "GraphIntegrationSkillMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          {
                            "condition": "isStudioCustomSkillsM1FrontendEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  (v16/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                  },
                                  (v12/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "tags"
                          },
                          {
                            "concreteType": "GraphIntegrationSkillTool",
                            "kind": "LinkedField",
                            "name": "tools",
                            "plural": true,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "source"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "alias": "skillDescription",
                        "kind": "ScalarField",
                        "name": "description"
                      }
                    ],
                    "type": "GraphIntegrationSkillItem"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v17/*: any*/),
                    "type": "GraphIntegrationActionDirectoryItem"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v17/*: any*/),
                    "type": "GraphIntegrationMcpServer"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v17/*: any*/),
                    "type": "GraphIntegrationMcpTool"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v17/*: any*/),
                    "type": "GraphIntegrationSkillDirectoryItem"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "args": (v10/*: any*/),
        "filters": [
          "cloudId",
          "relevantFor",
          "surface",
          "searchKeyword",
          "dimensionIds"
        ],
        "handle": "connection",
        "key": "SkillsList_AtlassianAgentStudioSkills_graphIntegration_componentDirectoryItems",
        "kind": "LinkedHandle",
        "name": "graphIntegration_componentDirectoryItems"
      },
      {
        "condition": "isStudioCustomSkillsM1FrontendEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "AuthenticationContext",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v16/*: any*/),
                  (v12/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "products",
        "args": [
          (v8/*: any*/),
          {
            "kind": "Literal",
            "name": "dimension",
            "value": "PRODUCTS"
          },
          (v9/*: any*/)
        ],
        "concreteType": "GraphIntegrationSkillDimensionMetadata",
        "kind": "LinkedField",
        "name": "graphIntegration_skillDimensionMetadata",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              (v14/*: any*/),
              (v12/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v15/*: any*/)
                ],
                "type": "GraphIntegrationSkillProductItem"
              }
            ]
          }
        ]
      },
      {
        "condition": "isForgeSkillsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "forgeApps",
            "args": [
              (v8/*: any*/),
              {
                "kind": "Literal",
                "name": "dimension",
                "value": "FORGE_APPS"
              }
            ],
            "concreteType": "GraphIntegrationSkillDimensionMetadata",
            "kind": "LinkedField",
            "name": "graphIntegration_skillDimensionMetadata",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a6653f1a1ff7b6936012fffcaca69d1c6f138190dbb860c41b727f029735e565",
    "metadata": {},
    "name": "AgentStudioSkillsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0c15e18c76ea23fa796d8844c569a0df";

export default node;
